<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 sm12 md12 lg9 xl8 class="pa-2">
            <template v-if="!silentLoading || silentLoading && silentLoadingSection == 'enews'">
                <h1>Prijava na e-novice</h1>
                <p>Na tem mestu urejate aktivne prijave na e-obveščanje za elektronski naslov <b>{{ email }}</b>. Po zaključenem urejanju kliknite "Shrani spremembe".</p>
                <unsubscribe-settings :from_link="false" unsubscribe_me_text="<b>Ne želim</b> prejemati e-novic" keep_all_text="<b>Želim prejemati</b> e-novice" keep_subscribe_text="Želim prejemati e-novice glede na moja zanimanja:" v-on:saved="onSaved" v-on:error="onErrorSaving($event)" />
                <v-snackbar
                        v-model="userDataSaved"
                        color="success"
                        top
                >
                    Spremembe so bile uspešno shranjene.
                    <v-btn
                            text
                            @click="userDataSaved = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
                <v-snackbar
                        v-model="userDataErrorSaving"
                        color="error"
                        top
                >
                    {{ userDataErrorSavingMSG }}
                    <v-btn
                            text
                            @click="userDataErrorSaving = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
            </template>
            <template v-if="silentLoading  && silentLoadingSection!='enews'">
                <div class="loader">
                    <empty-space />
                    <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
                </div>
            </template>
        </v-flex>
    </v-layout>
</template>

<script>
    import UnsubscribeSettings from "../UnsubscribeSettings";
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";

    export default {
        name: "EnewsTab",
        components: {UnsubscribeSettings, EmptySpace},
        computed: {
            email: utils.vuexBuildSetGet(this, 'profile', 'user.email'),
            enews: utils.vuexBuildSetGet(this, 'profile', 'user.enews'),
            silentLoading: utils.vuexBuildSetGet(this, 'profile', 'silentLoading'),
            silentLoadingSection: utils.vuexBuildSetGet(this, 'profile', 'silentLoadingSection'),
        },
        data: vm => ({
            userDataSaved: false,
            userDataErrorSaving: false,
            userDataErrorSavingMSG: '',
        }),
        methods: {
            onSaved() {
                this.userDataSaved = true;
                this.$store.dispatch('profile/silentAllAboutMe', {
                    'section': 'enews'
                });
            },
            onErrorSaving(error){
                this.userDataErrorSaving = true;
                this.userDataErrorSavingMSG = error.message;
            }
        }
    }
</script>

<style scoped>

    .loader {
        text-align: center;
    }
</style>